export type NotifySendBlocker =
	| "upgrade"
	| "no-sending-address"
	| "email-off"
	| "no-recipients"
	| "empty-message"

interface NotifySendInput {
	atLeastProPlan: boolean
	isEmailConfigured: boolean
	sendEmail: boolean
	recipientCount: number
	hasMessage: boolean
}

export function notifySendBlocker({
	atLeastProPlan,
	isEmailConfigured,
	sendEmail,
	recipientCount,
	hasMessage,
}: NotifySendInput): NotifySendBlocker | null {
	if (!atLeastProPlan) return "upgrade"
	if (!isEmailConfigured) return "no-sending-address"
	if (!sendEmail) return "email-off"
	if (recipientCount <= 0) return "no-recipients"
	if (!hasMessage) return "empty-message"
	return null
}
